import { Action, createReducer, on } from '@ngrx/store';
import { getClientUserFailure } from '@shared/store/client-user/client-user.actions';
import { CommonState } from '@shared/store/common.state';
import { getHelpCasesFailure } from '@shared/store/help-cases/help-cases.actions';
import { getInboxFailure } from '@shared/store/inbox/inbox.actions';
import { getLendersFailure } from '@shared/store/lender/lenders.actions';
import { getMortgageCasesFailure } from '@shared/store/mortgage-cases/mortgage-cases.actions';
import { getMortgagesFailure } from '@shared/store/mortgages/mortgages.actions';
import { getPortfolioFoldersFailure } from '@shared/store/portfolio-folders/portfolio-folders.actions';
import { getPropertiesFailure } from '@shared/store/properties/properties.actions';
import { getSmartSearchCasesFailure } from '@shared/store/smart-search-cases/smart-search-cases.actions';
import { getSmartSearchesFailure } from '@shared/store/smart-searches/smart-searches.actions';
import { getDashboardDataFailure, loadInitialPlatformData } from './common.actions';

export const commonInitialState: CommonState = {
  isInitialPlatformDataRequested: false,
};

const reducer = createReducer(
  commonInitialState,

  on(
    loadInitialPlatformData,
    (state): CommonState => ({
      ...state,
      isInitialPlatformDataRequested: true,
    }),
  ),

  on(
    getDashboardDataFailure,
    getClientUserFailure,
    getSmartSearchesFailure,
    getLendersFailure,
    getInboxFailure,
    getPortfolioFoldersFailure,
    getHelpCasesFailure,
    getPropertiesFailure,
    getMortgagesFailure,
    getSmartSearchCasesFailure,
    getMortgageCasesFailure,
    (state): CommonState => ({
      ...state,
      isInitialPlatformDataRequested: false,
    }),
  ),
);

export const commonReducer = (state: CommonState = commonInitialState, action: Action): CommonState => reducer(state, action);
